import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useTaskStore } from '../store/taskStore';

interface NewTaskModalProps {
  onClose: () => void;
}

export const NewTaskModal: React.FC<NewTaskModalProps> = ({ onClose }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const addTask = useTaskStore(state => state.addTask);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !description.trim()) return;

    setIsSubmitting(true);
    try {
      await addTask(title, description);
      onClose();
    } catch (error) {
      console.error('Failed to add task:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="cyberpunk-card w-full max-w-2xl rounded-lg neon-border">
        <form onSubmit={handleSubmit} className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-[#00fff9] font-mono cyberpunk-title">
              NEW_MISSION
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="p-1 hover:bg-[#ff00c133] rounded-full text-[#ff00c1] transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label htmlFor="title" className="block text-[#00fff9] font-mono mb-2">
                MISSION_TITLE
              </label>
              <input
                type="text"
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full bg-[#0d0d14] border border-[#00fff933] rounded-lg p-3 text-gray-300 focus:border-[#00fff9] focus:ring-1 focus:ring-[#00fff9] transition-colors"
                placeholder="Enter mission title..."
                required
              />
            </div>

            <div>
              <label htmlFor="description" className="block text-[#00fff9] font-mono mb-2">
                MISSION_BRIEF
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full bg-[#0d0d14] border border-[#00fff933] rounded-lg p-3 text-gray-300 focus:border-[#00fff9] focus:ring-1 focus:ring-[#00fff9] transition-colors h-32"
                placeholder="Enter mission details..."
                required
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 bg-[#00fff933] text-[#00fff9] rounded-lg font-mono hover:bg-[#00fff966] transition-colors disabled:opacity-50"
            >
              {isSubmitting ? 'ANALYZING...' : 'INITIATE_MISSION'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};